import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const KEY = "np_business_filter";
const BusinessCtx = createContext({ business: "", setBusiness: () => {} });

export function BusinessProvider({ children }) {
  const [business, setBusinessState] = useState("");

  useEffect(() => {
    const saved = localStorage.getItem(KEY) || "";
    setBusinessState(saved);
  }, []);

  const setBusiness = (v) => {
    setBusinessState(v);
    if (v) localStorage.setItem(KEY, v);
    else localStorage.removeItem(KEY);
  };

  const value = useMemo(() => ({ business, setBusiness }), [business]);

  return <BusinessCtx.Provider value={value}>{children}</BusinessCtx.Provider>;
}

export const useBusiness = () => useContext(BusinessCtx);
